import React from 'react';
import ResponsiveGameModeSelection from './ResponsiveGameModeSelection';

// This component now just wraps the responsive version
const GameModeSelection = () => {
  return <ResponsiveGameModeSelection />;
};

export default GameModeSelection;